import {Dayjs} from 'dayjs';

export function getEventDate(date: Dayjs | undefined): string {
    const yearRegex = new RegExp('(\\d{4}.*[.,])|(\\d{4}$)', 'gm');

    return date ? date?.format('ll').replace(yearRegex, '').trim() : '';
}
